<template>
  <bk-page 
		class="userInfoPage" 
		:class="{
			'userInfoPage-kisDZFlag':kisDZFlag,
			'userInfoPage-oblissDZFlag':oblissDZFlag,
			'userInfoPage-komoDZFlag':komoDZFlag,
		}"
	>
		<bk-view class="view-header-main">
			<bk-view class="view-box">
				<bk-view v-if="userInfo && userInfo.id && !userInfo.silent" class="view-userInfo" @click="userInfoItemClick">
					<bk-view class="view-avatar">
						<bk-image :src="userInfo.showAvatar"></bk-image>
					</bk-view>
					<bk-view class="view-info">
						<bk-view class="view-name">{{ userInfo.name }}</bk-view>
						<bk-view class="view-tip">
							<bk-lang>{{userInfo.email}}</bk-lang>
						</bk-view>
					</bk-view>
				</bk-view>

				<bk-view v-else class="view-userInfo" @click="userInfoItemClick">
					<bk-view class="view-avatar">
						<bk-image :src="defAvatar"></bk-image>
					</bk-view>
					<bk-view class="view-info">
						<bk-view class="view-name">
							<bk-lang code="userInfo_text_signName"></bk-lang>
						</bk-view>
						<bk-view class="view-tip">
							<bk-lang code="userInfo_text_signTip"></bk-lang>
						</bk-view>
					</bk-view>
				</bk-view>

				<bk-view class="view-menu">
					<bk-view class="view-menuItem" 
						:class="[`key-${item.key}`]" 
						v-for="item in menusList" 
						:key="item.key" 
						@click="handleItemClick(item)"
					>
						<bk-lang :code="item.langCode"></bk-lang>
					</bk-view>
				</bk-view>
			</bk-view>
		</bk-view>
    
    <bk-view class="view-list">
      <template v-for="item in itemList">
        <bk-view class="view-listItem" v-if="!item.hide" :class="[`key-${item.key}`]"  :key="item.key" @click="handleItemClick(item)">
          <bk-view class="view-left">
						<bk-icon :icon="item.icon" />
            <bk-lang 
							:class="{
								'view-showBadge': item.showBadge
							}" 
							:code="item.langCode" 
						/>
          </bk-view>
					<bk-view class="view-right-main">
						<bk-view class="view-value" v-if="item.value !=null">{{item.value}}</bk-view>
						<bk-view v-if="item.showIcon" class="view-icon"></bk-view>
						<bk-icon icon="icon-youjiantou"></bk-icon>
					</bk-view>
        </bk-view>
      </template>
    </bk-view>

    <bk-view v-if="userInfo && userInfo.id && !userInfo.silent" class="view-logout">
      <bk-button class="btn-signout" @click="logoutBtnClick" lang-code="userInfo_btn_signout"></bk-button>
			<!-- <bk-view class="view-delete-user">
				<bk-button type="text" langCode="userInfo_settings_deleteUser" @click="handleDeleteUser"></bk-button>
			</bk-view> -->
    </bk-view>

    <!-- <bk-button class="btn-notif"></bk-button> -->

    <transition name="rightFadeIn">
      <memberRights v-if="['membership','giftCard','packages'].includes(showPage)" :rightType="showPage" @close="showSubPage()" />
      <component v-else :is="showPage" pageType="navPage" @close="showSubPage(undefined)"/>
    </transition>

  </bk-page>
</template>

<script>

	import {shopReq, authReq, customerReq, baseReq } from '@/reqService/index';
	import memberRights from './subPages/memberRights/memberRights.vue';
	import LanguageConfig from './subPages/languageConfig/languageConfig';
	import personal from './subPages/personal/personal';
	import purchaseHistory from './subPages/purchaseHistory/purchaseHistory';
	import recently from './subPages/recently/recently';
	import settings from './subPages/settings/settings';
	import LanguageVerify from './subPages/languageVerify/languageVerify.vue';
	import Points from './subPages/points/points.vue';
	import shareInvitefriend from './subPages/shareInvitefriend/shareInvitefriend.vue';
  
	export default {
		name: 'userInfo',
		components: {
			memberRights,
			LanguageConfig,
			LanguageVerify,
			personal,
			purchaseHistory,
			recently,
			settings,
			Points,
			shareInvitefriend,
		},
		data () {
			let shopDetailInfo = this.$bk_getShopDetailInfo();
			
			return {
				shopDetailInfo,
				navBarInfo: {},
				showPage: undefined,
				userInfo: this.$bk_getUserInfo(),
				defAvatar: this.$bk_Global.defImages.Empty_Member_O,
				shareReadMarkStatus:false,
				showShareinvitefriendIcon:false,

				kisDZFlag: window.kisDZFlag,
				oblissDZFlag: window.oblissDZFlag,
				komoDZFlag:window.komoDZFlag,
				menusList: [
					{
						key: 'membership',
						icon: '',
						langCode: 'userInfo_menu_memberships'
					},
					{
						key: 'giftCard',
						icon: '',
						langCode: 'userInfo_menu_giftcards'
					},
					{
						key: 'packages',
						icon: '',
						langCode: 'userInfo_menu_packages'
					},
					{
						key: 'points',
						icon: '',
						langCode: 'userInfo_menu_points'
					},
				],
			};
		},
		computed:{
			itemList (){
				let languageValue = this.$bk_getLanguageType() ||'en';
				let langItem = this.$bk_findItem(this.$bk_Global.languageTypeList, languageValue, 'key');

				languageValue = langItem?.label || 'English';

				if (window.kisDZFlag) {
					return [
						{
							icon:'icon-a-PersonalInfo',
							key: 'personal',
							langCode: 'userInfo_item_personalInfo',
						},
						{
							icon:'icon-a-Purchasehistory',
							key: 'purchaseHistory',
							langCode: 'userInfo_item_purchaseHistory',
						},
						{
							icon:'icon-setting',
							key: 'settings',
							langCode: 'userInfo_item_settings',
						},
						{
							icon:'icon-Language',
							key: 'LanguageConfig',
							langCode: 'userInfo_item_language',
							value: languageValue
						},
					];
				}

				return [
					{
						icon:'icon-a-PersonalInfo',
						key: 'personal',
						langCode: 'userInfo_item_personalInfo',
					},
					{
						icon:'icon-a-Purchasehistory',
						key: 'purchaseHistory',
						langCode: 'userInfo_item_purchaseHistory',
					},
					{
						icon:'icon-a-RecentlyViewed',
						key: 'recently',
						langCode: 'userInfo_item_recentlyViewed',
					},
					{
						icon:'icon-setting',
						key: 'settings',
						langCode: 'userInfo_item_settings',
					},
					{
						icon:'icon-Language',
						key: 'LanguageConfig',
						langCode: 'userInfo_item_language',
						value: languageValue
					},
					{
						icon:'icon-Language',
						hide: this.$bk_getRunScene() != 'dev',
						key: 'LanguageVerify',
						langCode: 'userInfo_item_languageVerify',
					},
					{
						icon:'icon-fenxiang',
						key: 'shareInvitefriend',
						langCode: 'userInfo_item_referralRewards',
						showIcon: this.showShareinvitefriendIcon,
						showBadge: this.shareReadMarkStatus,
					}
				];
			},
		},
		created () {
			bkLog.log('userInfo:::', this.userInfo);
		},
		activated () {
			this.userInfo = this.$bk_getUserInfo();

			let token = this.$bk_getAccessToken();
			if (this.$bk_isNull(token)) {
				let that = this;
				window.viewCallback = function () {
					that.initData();
				};
				return;
			}
			this.initData();
		},
		methods: {
			initData (){
				if(this.shopDetailInfo?.id){
					this.requestGetPointRuleList();
				}
			},
			async requestGetPointRuleList (){
				const { compId, custId } = this.shopDetailInfo;
				const resRule = await baseReq.requestGetPointRuleList(this, { custId, compId });
				const { goodsSettingList=[]	} = resRule['PR011'];
	
				this.showShareinvitefriendIcon = goodsSettingList?.length;

				if(this.userInfo?.id){
					let params = { custId, userId:this.userInfo.id };

					const resMember = await customerReq.requestGetChainMemberInfo(this, params);

					if(resMember?.id){
						const res = await customerReq.requestGetShareReadMarkStatus(this, { memberId: resMember.id });
						this.shareReadMarkStatus = res==0;
					}
				}

			},
			async logoutBtnClick () {
				authReq.requestPostLoginOut(this);
				// 退出登录之后需要再静默登录一次, 重新获取userId, 此时的userId跟上一次静默登录返回结果相同
				let res = await authReq.requestPostGetViewId(this).catch(() => {});
				window.viewInfo = res;
				localStorage.removeItem('accessToken');
				this.$bk_setUserInfo(undefined);
				this.$bk_setAccessToken(undefined);
				this.userInfo = this.$bk_getUserInfo();
				this.shareReadMarkStatus = false;
				// window.reloadPath = '/userInfo';
				// this.$router.replace('/index');
			},

			userInfoItemClick () {
				bkLog.log('userInfoItemClick:::', this.userInfo);

				let that = this;

				if (!this.userInfo || !this.userInfo.id || this.userInfo.silent) {
					window.showLogin({
						callback: function (userInfo) {
							that.userInfo = userInfo;
							that.initData();
						}
					});
				}
			},
			handleItemClick (item){
				let that = this;
				
				if (['LanguageConfig'].indexOf(item.key) == -1) {
					if(!this.userInfo?.effectiveUser) {
						window.showLogin({
							callback: function (userInfo) {
								that.userInfo = userInfo;
								that.initData();
							}
						});
						return false;
					}
				}

				this.showSubPage(item.key);
			},
			showSubPage (type) {
				
				this.showPage = type;

				if (typeof window.setTabShow == 'function') {
					window.setTabShow(type ? false : true);
				}

				if(!type){
					this.userInfo = this.$bk_getUserInfo();
				}
			},
			handleDeleteUser (){
				this.$bk_confirm({
					langCode_message: 'userInfo_tip_deleteUser',
					langCode_cancelButton: 'a_cancel_button_text',
					langCode_confirmButton: 'userInfo_deleteUser_confirm_text',
				}).then(async () => {
					this.requestPostDeleteUser();
				}).catch((err) => {});
			},
			async requestPostDeleteUser () {
				if (this.bkLoad) {
					return;
				}
				this.bkLoad = true;

				let userInfo = this.$bk_getUserInfo();

				let res = await authReq.requestPostDeleteUser(this, {userId: userInfo.id}).catch(() => {});

				this.bkLoad = false;

				this.$bk_setUserInfo(undefined);
				this.$bk_setAccessToken(undefined);

				window.reloadPath = '/userInfo';
				this.$router.replace('/index');
			}
		}
	};
</script>

<style lang="less">

@import "./userInfo";

</style>